import { useRef, useState } from 'react';

export const useAnimationDelay = (fn = new Function(), timeout = 200) => {
	const [isActive, setActive] = useState(false);
	const [isOpened, setOpened] = useState(false);

	const delay = useRef(null);

	const handleClose = () => {
		if (delay.current !== null) {
			clearTimeout(delay.current);
		}

		setOpened(false);

		delay.current = setTimeout(() => {
			if (typeof fn === 'function' && isActive) {
				fn({
					isActive: false,
					isOpened: false,
				});
			}

			setActive(false);
		}, timeout);
	};

	const handleOpen = () => {
		if (delay.current !== null) {
			clearTimeout(delay.current);
		}

		setActive(true);

		delay.current = setTimeout(() => {
			if (typeof fn === 'function' && !isActive) {
				fn({
					isActive: true,
					isOpened: true,
				});
			}

			setOpened(true);
		}, timeout);
	};

	const toggle = () => {
		if (isActive) {
			handleClose();
		} else {
			handleOpen();
		}
	};

	return {
		isActive,
		isOpened,
		handleClose,
		handleOpen,
		toggle,
	};
};